module.exports = __webpack_public_path__ + "img/leaf_right.d97dfbbc.png";